import { ALERT_MESSAGES } from '../../messages/message.constant';
import { API_METHOD_CONSTANTS } from '../core';

export const DASHBOARD_METHOD_CONSTANT = {
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_WIDGET: 'DASHBOARD_WIDGET',
  DASHBOARD_WIDGET_SEQ: 'DASHBOARD_WIDGET_SEQ',
  DASHBOARD_DEFAULT: 'DASHBOARD_DEFAULT',

};
export const DASHBOARD_NGRX_CONSTANTS = {
  [DASHBOARD_METHOD_CONSTANT.DASHBOARD_DEFAULT]: {
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'setDefaultBusiness',
      STATE: 'setDefaultBusiness',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.DEFAULT_DASHBOARD_UPDATE_SUCCESS,
    },

  },
  [DASHBOARD_METHOD_CONSTANT.DASHBOARD]: {
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'createDashboard',
      STATE: 'createDashboard',
      SUCCESS_NOTIFICATION: true,
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.ADDED_SUCCESS,
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateDashboard',
      STATE: 'updateDashboard',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.UPDATE_SUCCESS,
    },
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getDashboardById',
      STATE: 'getDashboardById',
      SUCCESS_NOTIFICATION: false,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteDashboard',
      STATE: 'deleteDashboard',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.DELETE_SUCCESS,
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getDashboardsPaging',
      STATE: 'getDashboardsPaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getDashboardAllExport',
      STATE: 'dashboardAllList',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data.dashboards',
    },
  },

  [DASHBOARD_METHOD_CONSTANT.DASHBOARD_WIDGET]: {
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'createDashboardWidget',
      STATE: 'createDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.ADDED_SUCCESS,
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateDashboardWidget',
      STATE: 'updateDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.UPDATE_SUCCESS,
    },
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getDashboardWidgetById',
      STATE: 'getDashboardWidgetById',
      SUCCESS_NOTIFICATION: false,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteDashboardWidget',
      STATE: 'deleteDashboardWidget',
      SUCCESS_NOTIFICATION: true,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.DELETE_SUCCESS,
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getDashboardsPaging',
      STATE: 'getDashboardsPaging',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
      API_RESPONSE: 'data',
    },
  },
  [DASHBOARD_METHOD_CONSTANT.DASHBOARD_WIDGET_SEQ]: {
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateDashboardWidgetSequence',
      STATE: 'updateDashboardWidgetSequence',
      SUCCESS_NOTIFICATION: false,
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: 'Widget Sequence Updated Successfully',
    },

  },
};
